export const MAX_NUMBER_OF_TOPICS_PER_ROW = 10;
